import $ = require('jquery');
import ModuleHelper = require('./ModuleHelper');
/**
 * Drag helper for new modules (from module selector)
 */

    class BlankModuleHelper extends ModuleHelper {
        protected restrictedTooltipOptions = {
            anchorOffset: -12
        };
        create(sourceElem: JQuery) {
            let item = sourceElem;
            let itemIcon = item.find('.image');
            // webcomponents use the background-image css property for the icon
            // in the style attribute
            let itemStyle = itemIcon.attr('style');

            if (typeof(itemStyle) !== 'undefined') {
                itemStyle = itemStyle.replace('"', '\'');
            } else {
                itemStyle = "";
            }

            let dragElement = $('<div class="drag-container"><div class="diye">' +
                '<div class="drag-placeholder">' +
                    '<div class="opaque"></div>' +
                    '<span class="' + itemIcon.attr('class') +
                    '" style="' + itemStyle + '"></span><br />' +
                    '<span class="label">' + item.attr('data-moduleLabel') + '</span>' +
                '</div>' +
            '</div></div>');

            // if the item icon is a sprite, set it to the dragging position
            if (item.attr('data-iconissprite') === "1" && itemIcon.hasClass('icon')) {
                dragElement.find('.icon').addClass('drag');
            }

            dragElement.appendTo('body');

            //need to set correct dimensions, because the draggable doesn't do that right
            let placeholder = dragElement.find('.drag-placeholder');
            dragElement.css('height', placeholder.height()).css('width', placeholder.width());

            return dragElement;
        }
    }

export = BlankModuleHelper;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/common/js/dd/BlankModuleHelper.ts
 **/